import { Component, EventEmitter, Input, Output } from "@angular/core";
import {
  CirculationStatus,
  IPermissionExtendedStep,
  IStepInit
} from "src/app/interfaces";
import { HelpTarget } from "src/app/interfaces/helpTarget";

@Component({
    selector: "circ-step-grid",
    templateUrl: "./step-grid.component.html",
    styleUrls: ["./step-grid.component.scss"],
    standalone: false
})
export class StepGridComponent {
  @Input() steps: IPermissionExtendedStep[];
  @Input() canAddStep: boolean;
  @Input() public circStatus: CirculationStatus;

  @Output() public workClick = new EventEmitter<IStepInit>();
  @Output() public forwardClick = new EventEmitter<IStepInit>();
  @Output() public overrideClick = new EventEmitter<IStepInit>();
  @Output() public editClick = new EventEmitter<IStepInit>();
  @Output() public addClick = new EventEmitter();
  @Output() public reorderClick = new EventEmitter();

  public readonly helpTarget = HelpTarget.Steps;

  public onWork(value?: IStepInit): void {
    this.workClick.next(value);
  }

  public onForward(value?: IStepInit): void {
    this.forwardClick.next(value);
  }

  public onOverrideStep(value?: IStepInit): void {
    this.overrideClick.next(value);
  }

  public onEdit(value?: IStepInit): void {
    this.editClick.next(value);
  }

  public reorderSteps(): void {
    this.reorderClick.next(this.steps);
  }

  public addStep(): void {
    this.addClick.next(this.steps);
  }
}
